import { render } from "./ImportView.vue?vue&type=template&id=00c1fa73"
import script from "./ImportView.vue?vue&type=script&lang=js"
export * from "./ImportView.vue?vue&type=script&lang=js"
script.render = render

export default script